export const paginationDefaults = {
  startingRowOption: 250,
  allRowOptions: [25, 50, 100, 250, 500],
};
